<div class="w-full p-5">
  <form class="form-grid" [formGroup]="formFila">
    <div class="grid w-full grid-cols-2 gap-4">
      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="name"> Nome: </label>
        <input
          type="text"
          id="name"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          formControlName="name"
        />
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="trading">Descrição:</label>
        <input
          type="text"
          id="description"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          formControlName="description"
        />
      </div>

      <div class="form-group" *ngIf="podeEscolherEmpresa">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="type"> Empresa: </label>
        <ng-select
          notFoundText="Nenhum item encontrado"
          [searchable]="false"
          placeholder="Empresa"
          formControlName="companyId"
        >
          <ng-option *ngFor="let company of companies" [value]="company.id">
            {{ company.name }}
          </ng-option>
        </ng-select>
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="onlineSupportEmail"
          >E-mail de suporte online:</label
        >
        <input
          type="email"
          id="onlineSupportEmail"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          placeholder="E-mail de suporte online"
          formControlName="onlineSupportEmail"
        />
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="offlineSupportEmail"
          >E-mail de suporte offline:</label
        >
        <input
          type="email"
          id="offlineSupportEmail"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          placeholder="E-mail de suporte offline"
          formControlName="offlineSupportEmail"
        />
      </div>

      <div class="flex items-center col-span-2 text-sm font-bold text-gray-700">
        <input
          type="checkbox"
          id="showPatientData"
          class="mr-3 form-input form-checkbox on-white check-pink"
          formControlName="showPatientData"
        />
        <label for="showPatientData">Exibir dados do paciente (sinais vitais e triagem) no atendimento</label>
      </div>
    </div>
  </form>
</div>
